// extracted by mini-css-extract-plugin
export default {"productBoxTitle":"fbE_X3","productBox":"vcXZBx"};